export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';